import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';

function SectionFour({ data }: any) {
  if (isEmpty(data?.dataSet)) return null;
  return (
    <SectionWrapper className='section-four'>
      <div className='container content'>
        <img className='image' src={convertDatasets(data?.dataSet, 'imageUrl', true)} />
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  .content {
    padding: 0 15px;
    .image {
      width: 100%;
    }
  }
`;
export default SectionFour;
